/*
 *
 * LoginPage actions
 *
 */

import {
  LOGIN,
  LOGOUT,
  LOGIN_ERROR,
  LOGIN_REDIRECT,
  LOGIN_SUCCESS,
  SET_OTP_ERROR,
} from './constants';

export function login(username, password, code, fp, navigate) {
  return {
    type: LOGIN,
    username,
    password,
    code,
    fp,
    navigate,
  };
}
export function logout() {
  return {
    type: LOGOUT,
  };
}
export function loginSuccess(data) {
  return {
    type: LOGIN_SUCCESS,
    data,
  };
}

export function loginError(error) {
  return {
    type: LOGIN_ERROR,
    error,
  };
}

export function loginRedirect() {
  return {
    type: LOGIN_REDIRECT,
  };
}

export function setOtpError(data) {
  return {
    type: SET_OTP_ERROR,
    data,
  };
}
